import { styled } from "@mui/material/styles";
import { Box, ButtonBase } from "@mui/material";

export const EmailEditorContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const SectionTitle = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#344054",
}));

export const ToggleRow = styled(Box)(() => ({
  display: "flex",
  gap: 8,
  alignItems: "center",
}));

export const ToggleLabel = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: "#475467",
}));

export const FormRow = styled(Box)(() => ({
  display: "flex",
  gap: 12,
  width: "100%",
}));

export const EditorContainer = styled(Box)(() => ({
  border: "1px solid #E4E7EC",
  borderRadius: 8,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  minHeight: 326,
}));

export const EditorOptionRow = styled(Box)(() => ({
  display: "flex",
  gap: 16,
  padding: "4px 6px",
  borderTop: "1px solid #E4E7EC",
  backgroundColor: "#F9FAFB",
  flexWrap: "wrap",
}));

export const EditorOption = styled(Box)(() => ({
  display: "flex",
  gap: 2,
  alignItems: "center",
}));

export const EditorOptionLabel = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#475467",
}));

export const ActionButtonsRow = styled(Box)(() => ({
  display: "flex",
  gap: 16,
  justifyContent: "flex-end",
  alignItems: "center",
  padding: "16px 24px",
  borderTop: "1px solid #E4E7EC",
}));

export const SendButton = styled(ButtonBase)(() => ({
  backgroundColor: "#12B76A",
  color: "#FFFFFF",
  padding: "10px 20px",
  borderRadius: 8,
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  display: "flex",
  gap: 8,
  alignItems: "center",
  "&:hover": {
    backgroundColor: "#10A85C",
  },
}));

export const ScheduleButton = styled(ButtonBase)(() => ({
  border: "1px solid #12B76A",
  color: "#12B76A",
  padding: "10px 20px",
  borderRadius: 8,
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  display: "flex",
  gap: 8,
  alignItems: "center",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#F0FDF4",
  },
}));

